export enum EDynV2SessionEvent {
  SWITCHED = 'SWITCHED',
  CLOSED = 'CLOSED',
  EMPTY = 'EMPTY',
}
